<!-- 由 woniu6162 创建于 2021-10-19 星期二 -->
<template>
  <div class="p-box">
    <div class="pb_wrap">
      <template v-for="(item, index) in datum.slice(0, rank)">
        <div :key="index" :class="['pb_item', fBg(item.rank)]">
          <img :src="fNumPic(item.rank)" class="pb_i_numpic" />
          <div class="pb_i_info">
            <img :src="item.avatar" class="pb_io_pic" />
            <div class="pb_io_right">
              <div class="pb_ior_up">
                <div class="pb_ioru_name">{{ item.nickname }}</div>
                <img :src="fRank(item.rank)" class="pb_ioru_pic" />
                <div
                  class="pb_ioru_copy"
                  :data-clipboard-text="item.nickname"
                  @click="tapCopy('.pb_ioru_copy')"
                >
                  复制昵称
                </div>
              </div>
              <div class="pb_ior_down">
                <div class="pb_iord_fans">
                  {{ `粉丝 ${item.follower_count2}` }}
                </div>
                <div class="pb_iord_effect">影响力</div>
                <div class="pb_iord_hot">
                  <img :src="hotPic" class="pb_iordh_pic" />
                  <div class="pb_iordh_force">{{ item.effect_value2 }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pb_i_video">
            <div class="pb_iv_out">
              <template v-for="(si, ii) in item.video_list">
                <div :key="ii" class="pb_iv_wrap">
                  <div class="pb_ivw_out">
                    <img :src="si.item_cover" class="pb_iv_video" />
                    <!-- <img
                      :src="playPic"
                      class="pb_ivwo_play"
                      @click="viewVideo(si.share_url)"
                    /> -->
                    <div
                      class="pb_ivwo_copy"
                      :data-clipboard-text="si.share_url"
                      @click="tapCopy('.pb_ivwo_copy')"
                    >
                      <i class="iconfont iconlianjie" />
                      <div>复制播放链接</div>
                    </div>
                  </div>
                  <div class="pb_ivw_name">{{ si.title }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </div>
    <template v-for="(item, index) in datum.slice(rank)">
      <pCard :key="index" :datum="item" @viewVideo="viewVideo" />
    </template>
  </div>
</template>

<script>
import pCard from './p-card.vue'
import Clipboard from 'clipboard'
export default {
  name: 'p-box',

  mixins: [],

  components: { pCard },

  props: {
    datum: {},
    rank: {
      type: Number,
      default: 3
    }
  },

  data() {
    return {
      hotPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_hot',
      playPic: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_play',
      rank1: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank1',
      rank2: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank2',
      rank3: 'https://cdnvue.gymcity.com.cn/uploads/trackhot_rank3',
      medal1: 'https://cdnvue.gymcity.com.cn/uploads/score_rank_first',
      medal2: 'https://cdnvue.gymcity.com.cn/uploads/score_rank_second',
      medal3: 'https://cdnvue.gymcity.com.cn/uploads/score_rank_third'
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    fUrl(val) {
      console.log('val', val)
      return `${val}?x-oss-process=video/snapshot,t_1,m_fast`
    },
    fNumPic(val) {
      let str
      switch (val) {
        case 1:
          str = this.rank1
          break
        case 2:
          str = this.rank2
          break
        case 3:
          str = this.rank3
          break
        default:
          break
      }
      return str
    },
    fRank(val) {
      let str
      switch (val) {
        case 1:
          str = this.medal1
          break
        case 2:
          str = this.medal2
          break
        case 3:
          str = this.medal3
          break
        default:
          break
      }
      return str
    },
    // 名次背景色
    fBg(val) {
      let str = ''
      switch (String(val)) {
        case '1':
          str = 'pb_item_one'
          break
        case '2':
          str = 'pb_item_two'
          break
        case '3':
          str = 'pb_item_three'
          break
        default:
          break
      }
      return str
    },
    // 复制
    tapCopy(val) {
      let clipboard = new Clipboard(val)
      clipboard.on('success', () => {
        this.$toast.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$toast.fail('复制失败，请手动复制')
      })
    },
    viewVideo(url) {
      this.$emit('viewVideo', url)
    }
  }
}
</script>

<style lang="scss" scoped>
.p-box {
  position: relative;
  z-index: 1;
  .pb_wrap {
    .pb_item {
      margin-top: 4.3vw;
      width: 90vw;
      box-sizing: border-box;
      border-radius: 1.1vw;
      padding: 3.5vw 0 5.9vw;
      // box-shadow: 0vw 0vw 1.1vw 0vw rgba(0, 0, 0, 0.06);
      position: relative;
      .pb_i_numpic {
        position: absolute;
        top: 0;
        left: 0;
        width: 13.3vw;
        height: 13.3vw;
      }
      .pb_i_info {
        padding-left: 6.4vw;
        display: flex;
        align-items: center;
        .pb_io_pic {
          margin-left: 2.1vw;
          width: 12.8vw;
          height: 12.8vw;
          box-sizing: border-box;
          background-color: #d8d8d8;
          border-radius: 50%;
        }
        .pb_io_right {
          margin-left: 2.7vw;
          .pb_ior_up {
            display: flex;
            align-items: center;
            text-align: left;
            .pb_ioru_name {
              max-width: 40.8vw;
              font-size: 4.3vw;
              font-weight: 600;
              color: #000;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              word-break: break-all;
            }
            .pb_ioru_pic {
              margin-left: 1.6vw;
              width: 4.8vw;
              object-fit: cover;
            }
            .pb_ioru_copy {
              margin-left: 2.7vw;
              font-size: 3.2vw;
              color: rgba(0, 0, 0, 0.5);
            }
          }
          .pb_ior_down {
            margin-top: 0.8vw;
            display: flex;
            align-items: center;
            .pb_iord_fans {
              font-size: 3.2vw;
              color: rgba(0, 0, 0, 0.5);
            }
            .pb_iord_effect {
              margin-left: 2.7vw;
              font-size: 3.2vw;
              color: rgba(0, 0, 0, 0.5);
            }
            .pb_iord_hot {
              margin-left: 1.1vw;
              display: flex;
              align-items: center;
              .pb_iordh_pic {
                margin-left: 1.1vw;
                width: 2.1vw;
                object-fit: cover;
              }
              .pb_iordh_force {
                margin-left: 0.5vw;
                font-size: 3.5vw;
                font-weight: 600;
                color: #ff5c5c;
              }
            }
          }
        }
      }
      .pb_i_video {
        margin-top: 4vw;
        width: 100%;
        box-sizing: border-box;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }
        .pb_iv_out {
          margin-left: -2.7vw;
          width: fit-content;
          padding: 0 6.4vw;
          display: flex;
          .pb_iv_wrap {
            margin-left: 2.7vw;
            width: 24.5vw;
            box-sizing: border-box;
            .pb_ivw_out {
              width: 24.5vw;
              height: 32.8vw;
              border-radius: 0.5vw;
              background-color: rgba(0, 0, 0, 0.5);
              overflow: hidden;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              .pb_iv_video {
                position: absolute;
                top: 0;
                left: 0;
                width: 24.5vw;
                height: 32.8vw;
                box-sizing: border-box;
                border-radius: 0.5vw;
              }
              .pb_ivwo_play {
                width: 10.7vw;
                height: 10.7vw;
                position: relative;
                z-index: 1;
              }
              .pb_ivwo_copy {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 2.7vw;
                line-height: 5vw;
                font-weight: 600;
                color: #ffffff;
                position: absolute;
                z-index: 1;
                bottom: 1.9vw;
                background: linear-gradient(
                  180deg,
                  rgba(0, 0, 0, 0.3),
                  rgba(0, 0, 0, 0.02)
                );
                & > i {
                  margin-right: 0.8vw;
                  font-size: 3.2vw;
                  font-weight: normal;
                }
              }
            }
            .pb_ivw_name {
              margin-top: 2.1vw;
              text-align: left;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
      }
    }
    .pb_item_one {
      background-image: linear-gradient(180deg, #fffaed 0%, #fff 100%);
      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        top: -0.8vw;
        left: -0.8vw;
        right: -0.8vw;
        bottom: -0.8vw;
        border-radius: 1.1vw;
        background: linear-gradient(180deg, #fce395 0%, #fff 100%);
      }
    }
    .pb_item_two {
      background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        top: -0.8vw;
        left: -0.8vw;
        right: -0.8vw;
        bottom: -0.8vw;
        border-radius: 1.1vw;
        background: linear-gradient(180deg, #dcdbdb 0%, #fff 100%);
      }
    }
    .pb_item_three {
      background-image: linear-gradient(180deg, #fff 0%, #fff 100%);
      &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        top: -0.8vw;
        left: -0.8vw;
        right: -0.8vw;
        bottom: -0.8vw;
        border-radius: 1.1vw;
        background: linear-gradient(180deg, #ffdec4 0%, #fff 100%);
      }
    }
  }
}
</style>
